module.exports = __webpack_public_path__ + "static/media/icon_attente_big_bleu.5cd4cb86.svg";